import * as React from 'react'

export type ContextValues = {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  toggle: () => void
  isLt768: boolean
}

export const NavStateContext = React.createContext<ContextValues | undefined>(
  undefined
)

NavStateContext.displayName = 'NavbarContext'
